import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DataService } from '../shared/network/data.service';
import { ProjectService } from '../shared/project/project.service';

@Component({
  templateUrl: './header.component.html',
  selector: 'main-header'
})
export class HeaderComponent implements OnInit {
    public showMenu: boolean = false;
    public showCacheClearBtn = false;
    @ViewChild('btnShowMenu') btnShowMenu: ElementRef;
    @ViewChild('menu') menu: ElementRef;

    constructor(private renderer: Renderer2, private dataService: DataService, private projectService: ProjectService) {
        this.renderer.listen('window', 'click', (e:Event) => {
           if (e.target !== this.btnShowMenu.nativeElement && e.target!==this.menu.nativeElement){
               this.showMenu = false;
           }
       });
    }

    ngOnInit(): void {
        this.showCacheClearBtn = window.location.host.indexOf('localhost') >=0; 
    }

    public async clearCacheAndReload() {
        await this.dataService.post('processing/clearCache', {
            projectId : this.projectService.projectId
        });
        window.location.reload();
    }
}
